import React, { useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Image,
  OverlayTrigger,
  Table,
  Tooltip
} from 'react-bootstrap'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PIM_ORG_FACTION } from '../../../../router/routes'
import EditGroup from './edit-org'
import { useSelector } from 'react-redux'
import detailImg from '../../../../images/Detail.svg'
import editImg from '../../../../images/Edit.svg'
import { FaCircleChevronDown, FaCircleChevronUp } from 'react-icons/fa6'
import { getFactionsAPI } from '../../../../services/factions'
import { getDepartmentsAPI } from '../../../../services/departments'
import { getTeamsAPI } from '../../../../services/teams'
import { getPositionAPI } from '../../../../services/position'
import { AiOutlineEnter } from 'react-icons/ai'
import TableSkeletonBody from '../../../custom/TableSkeletonBody'

export default function Index({
  data,
  isRefresh,
  setIsRefresh,
  fnGetData,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum,
  isLoading
}) {
  let [searchParams, setSearchParams] = useSearchParams()
  const divisionId = searchParams.get('divisionId')
  const [showEdit, setShowEdit] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const orgId = useSelector((state) => state.roleReducer.role)
  const navigate = useNavigate()

  const [detailTable, setDetailTable] = useState()
  const [expand, setExpand] = useState(false)

  const [detailTable2, setDetailTable2] = useState()
  const [expand2, setExpand2] = useState(false)

  const [detailTable3, setDetailTable3] = useState()
  const [expand3, setExpand3] = useState(false)

  const [detailTable4, setDetailTable4] = useState()
  const [expand4, setExpand4] = useState(false)

  const handleClick = (d) => {
    navigate(
      `${PIM_ORG_FACTION}?orgId=${orgId}&divisionId=${d.id}&nameGroup=${d.division_en}`
    )
  }

  const handleEditButtonClick = () => {
    setShowEdit(true)
  }

  const handleExpand = async (d) => {
    if (!expand[d.id]) {
      const params = { orgId, divisionId: d.id }
      const result = await getFactionsAPI(params)
      if (result && result.status) {
        setExpand({ ...expand, [d.id]: true })
        setDetailTable({ ...detailTable, [d.id]: result.result })
      }
    } else {
      setExpand({ ...expand, [d.id]: !expand[d.id] })
    }
  }

  const handleExpand2 = async (s) => {
    if (!expand2[s.id]) {
      const params = { orgId, divisionId: s.dsId, factionId: s.id }
      const result = await getDepartmentsAPI(params)
      if (result && result.status) {
        setExpand2({ ...expand2, [s.id]: true })
        setDetailTable2({ ...detailTable2, [s.id]: result.result })
      }
    } else {
      setExpand2({ ...expand2, [s.id]: !expand2[s.id] })
    }
  }

  const handleExpand3 = async (f) => {
    if (!expand3[f.id]) {
      const params = {
        orgId,
        divisionId: f.dsId,
        factionId: f.fac_id,
        departmentId: f.id
      }
      const result = await getTeamsAPI(params)
      if (result && result.status) {
        setExpand3({ ...expand3, [f.id]: true })
        setDetailTable3({ ...detailTable3, [f.id]: result.result })
      }
    } else {
      setExpand3({ ...expand3, [f.id]: !expand3[f.id] })
    }
  }

  const handleExpand4 = async (g) => {
    if (!expand4[g.id]) {
      const params = {
        orgId,
        divisionId: g.dsId,
        factionId: g.fac_id,
        departmentId: g.dm_id,
        teamId: g.id
      }
      const result = await getPositionAPI(params)
      if (result && result.status) {
        setExpand4({ ...expand4, [g.id]: true })
        setDetailTable4({ ...detailTable4, [g.id]: result.result })
      }
    } else {
      setExpand4({ ...expand4, [g.id]: !expand4[g.id] })
    }
  }

  return (
    <>
      <Table hover>
        <thead className="bg-hrms" style={{ position: 'sticky', top: '0px' }}>
          <tr className="font-title-table">
            <th className="fw-normal ">#</th>
            <th className="fw-normal ">Group</th>
            <th className="fw-normal ">Group EN</th>
            <th className="fw-normal ">Group TH</th>
            <th className="fw-normal text-center"> Count of Employee</th>
            <th className="fw-normal text-center" style={{ width: '6rem' }}>
              {' '}
              Action
            </th>
            <th className="fw-normal text-center" style={{ width: '6rem' }}>
              {' '}
              Expand
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <TableSkeletonBody colSpan={7} rowSpan={10} />
          ) : data.length > 0 ? (
            data.map((d, i) => (
              <>
                <tr key={i} className={`fw-light font-small-2 border-1`}>
                  <td>{i + 1}</td>
                  <td>{d.division}</td>
                  <td className="">{d.division_en}</td>
                  <td className="">{d.division_th}</td>
                  <td className="text-center">{d.count_emp}</td>
                  <td className="">
                    <span className="d-flex justify-content-center">
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-detail">Detail</Tooltip>
                          }
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              handleClick(d)
                            }}
                          >
                            <Image
                              src={detailImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                      <ButtonToolbar>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-detail">Edit</Tooltip>}
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 d-flex justify-content-center"
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              setDetailTable(d)
                              handleEditButtonClick()
                            }}
                          >
                            <Image
                              src={editImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                    </span>
                  </td>
                  <td className="text-center">
                    {expand[d.id] ? (
                      <FaCircleChevronDown
                        className="text-primary"
                        style={{
                          fontSize: '20px'
                        }}
                        onClick={() => handleExpand(d)}
                      />
                    ) : (
                      <FaCircleChevronUp
                        className="text-primary"
                        style={{
                          fontSize: '20px'
                        }}
                        onClick={() => handleExpand(d)}
                      />
                    )}
                  </td>
                </tr>
                {expand[d.id] &&
                  detailTable[d.id] &&
                  detailTable[d.id].map((s, index) => (
                    <>
                      <tr key={index} className={`border-cus`}>
                        <td className="font-small-2 text-secondary"></td>
                        <td className="font-small-2 text-secondary ">
                          <div
                            style={{
                              fontSize: '13px'
                            }}
                          >
                            <span className="me-2 mb-5 ">
                              <AiOutlineEnter
                                className="flipped-text fw-light"
                                style={{
                                  opacity: '0.8',
                                  marginTop: '-10px',
                                  fontSize: '25px'
                                }}
                              />
                            </span>
                            {s.faction}
                          </div>
                        </td>
                        <td className="font-small-2 text-secondary">
                          <div
                            style={{
                              fontSize: '13px'
                            }}
                          >
                            {s.faction_en}
                          </div>
                        </td>
                        <td className="font-small-2 text-secondary">
                          <div
                            style={{
                              fontSize: '13px'
                            }}
                          >
                            {s.faction_th}
                          </div>
                        </td>{' '}
                        <td className="font-small-2 text-secondary text-center">
                          <div
                            style={{
                              fontSize: '13px'
                            }}
                          >
                            {s.count_emp}
                          </div>
                        </td>
                        <td></td>
                        <td className="text-center">
                          {expand2[s.id] ? (
                            <FaCircleChevronDown
                              className="text-secondary"
                              style={{
                                fontSize: '20px',
                                opacity: '0.7'
                              }}
                              onClick={() => handleExpand2(s)}
                            />
                          ) : (
                            <FaCircleChevronUp
                              className="text-secondary"
                              style={{
                                fontSize: '20px',
                                opacity: '0.7'
                              }}
                              onClick={() => handleExpand2(s)}
                            />
                          )}
                        </td>
                      </tr>

                      {expand2[s.id] &&
                        detailTable2[s.id] &&
                        detailTable2[s.id].map((n, index) => (
                          <>
                            <tr key={index} className={`border-cus`}>
                              <td className="font-small-2 text-secondary "></td>
                              <td className="font-small-2 text-secondary ">
                                <div
                                  className="me-2"
                                  style={{
                                    fontSize: '13px'
                                  }}
                                >
                                  <span className="me-2 mb-5 ">
                                    <AiOutlineEnter
                                      className="flipped-text fw-light"
                                      style={{
                                        opacity: '0.8',
                                        marginTop: '-10px',
                                        marginLeft: '30px',
                                        fontSize: '25px'
                                      }}
                                    />
                                  </span>
                                  {n.department}
                                </div>
                              </td>
                              <td className="font-small-2 text-secondary">
                                <div
                                  style={{
                                    fontSize: '13px'
                                  }}
                                >
                                  {n.department_en}
                                </div>
                              </td>
                              <td className="font-small-2 text-secondary">
                                <div
                                  style={{
                                    fontSize: '13px'
                                  }}
                                >
                                  {n.department_th}
                                </div>
                              </td>
                              <td className="font-small-2 text-secondary text-center">
                                <div
                                  style={{
                                    fontSize: '13px'
                                  }}
                                >
                                  {n.count_emp}
                                </div>
                              </td>{' '}
                              <td></td>
                              <td className="text-center">
                                {expand3[n.id] ? (
                                  <FaCircleChevronDown
                                    className="text-secondary"
                                    style={{
                                      fontSize: '20px',
                                      opacity: '0.7'
                                    }}
                                    onClick={() => handleExpand3(n)}
                                  />
                                ) : (
                                  <FaCircleChevronUp
                                    className="text-secondary"
                                    style={{
                                      fontSize: '20px',
                                      opacity: '0.7'
                                    }}
                                    onClick={() => handleExpand3(n)}
                                  />
                                )}
                              </td>
                            </tr>
                            <>
                              {expand3[n.id] &&
                                detailTable3[n.id] &&
                                detailTable3[n.id].map((f, indexf) => (
                                  <>
                                    <tr key={indexf} className={`border-cus`}>
                                      <td className="font-small-2 text-secondary "></td>
                                      <td className="font-small-2 text-secondary">
                                        <div
                                          style={{
                                            fontSize: '13px'
                                          }}
                                        >
                                          <span className="me-2 mb-5 ">
                                            <AiOutlineEnter
                                              className="flipped-text fw-light"
                                              style={{
                                                opacity: '0.8',
                                                marginTop: '-10px',
                                                marginLeft: '60px',
                                                fontSize: '25px'
                                              }}
                                            />
                                          </span>
                                          {f.team_en}
                                        </div>
                                      </td>
                                      <td className="font-small-2 text-secondary">
                                        <div
                                          style={{
                                            fontSize: '13px'
                                          }}
                                        >
                                          {f.team_th}
                                        </div>
                                      </td>
                                      <td></td>
                                      <td className="font-small-2 text-secondary text-center">
                                        <div
                                          style={{
                                            fontSize: '13px'
                                          }}
                                        >
                                          {f.count_emp}
                                        </div>
                                      </td>
                                      <td className="font-small-2 text-secondary "></td>
                                      <td className="text-center">
                                        {expand4[f.id] ? (
                                          <FaCircleChevronDown
                                            className="text-secondary"
                                            style={{
                                              fontSize: '20px',
                                              opacity: '0.7'
                                            }}
                                            onClick={() => handleExpand4(f)}
                                          />
                                        ) : (
                                          <FaCircleChevronUp
                                            className="text-secondary"
                                            style={{
                                              fontSize: '20px',
                                              opacity: '0.7'
                                            }}
                                            onClick={() => handleExpand4(f)}
                                          />
                                        )}
                                      </td>
                                    </tr>
                                    {expand4[f.id] &&
                                      detailTable4[f.id] &&
                                      detailTable4[f.id].map((g, indexf) => (
                                        <>
                                          <tr
                                            key={indexf}
                                            className={`border-cus`}
                                          >
                                            <td className="font-small-2 text-secondary "></td>
                                            <td
                                              className="font-small-2 text-secondary"
                                              style={{
                                                fontSize: '13px'
                                              }}
                                            >
                                              <span className="me-2 mb-5 ">
                                                <AiOutlineEnter
                                                  className="flipped-text fw-light"
                                                  style={{
                                                    opacity: '0.8',

                                                    marginTop: '-10px',
                                                    marginLeft: '90px',

                                                    fontSize: '25px'
                                                  }}
                                                />
                                              </span>
                                              {g.position_en}
                                            </td>

                                            <td className="font-small-2 text-secondary">
                                              <div
                                                style={{
                                                  fontSize: '13px'
                                                }}
                                              >
                                                {g.position_th} (L{g.level_id})
                                              </div>
                                            </td>
                                            <td
                                              className="font-small-2 text-secondary text-center"
                                              style={{
                                                fontSize: '13px'
                                              }}
                                            ></td>

                                            <td className="font-small-2 text-secondary text-center">
                                              <div
                                                style={{
                                                  fontSize: '13px'
                                                }}
                                              >
                                                {g.count_emp}
                                              </div>
                                            </td>

                                            <td className="font-small-2 text-secondary">
                                              <div
                                                style={{
                                                  fontSize: '13px'
                                                }}
                                              ></div>
                                            </td>
                                            <td></td>
                                          </tr>
                                        </>
                                      ))}
                                  </>
                                ))}
                            </>
                          </>
                        ))}
                    </>
                  ))}
              </>
            ))
          ) : !orgId ? (
            <tr className="mb-0">
              <td className="text-center small" colSpan={13}>
                - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
              </td>
            </tr>
          ) : (
            <tr className="fw-light ">
              <td colSpan={7} className="text-center">
                - No data -
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {showEdit && (
        <EditGroup
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          orgId={orgId}
          divisionId={divisionId}
          detail={detailTable}
          setIsSave={setIsSave}
          showCreate={showEdit}
          isSave={isSave}
          fnGetData={fnGetData}
          setShowCreate={setShowEdit}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </>
  )
}
